'use strict';

import * as presenterList from '../actions/presenterList';

var defaultState = {
    isDeletePictureOverlayOpen: false,
    isAddOverlayOpen: false,
    isEditOverlayOpen: false,
    isDeleteOverlayOpen: false,
    presenterToDelete: null,
    presenters: [],
    formMode: 'add',
    presenterToEdit: null,
    changingPictureOfPresenter: null,
    deletingPictureOfPresenter: null,
    defaultForm: {
        id: 0,
        name: '',
        bio: ''
    },
    searchResults: []
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case presenterList.HIDE_DELETE_PICTURE_OVERLAY:

            return Object.assign({}, state, {
                isDeletePictureOverlayOpen: false,
                deletingPictureOfPresenter: null
            });

        case presenterList.SHOW_DELETE_PICTURE_OVERLAY:

            return Object.assign({}, state, {
                isDeletePictureOverlayOpen: true,
                deletingPictureOfPresenter: action.presenter
            });

        case presenterList.CHANGE_PICTURE_OF_PRESENTER:

            return Object.assign({}, state, {
                changingPictureOfPresenter: action.presenter
            });

        case presenterList.SHOW_EDIT_PRESENTER_OVERLAY:

            return Object.assign({}, state, {
                isEditOverlayOpen: true,
                formMode: 'edit',
                presenterToEdit: action.presenter
            });

        case presenterList.HIDE_EDIT_PRESENTER_OVERLAY:

            return Object.assign({}, state, {
                isEditOverlayOpen: false,
                presenterToEdit: null
            });

        case presenterList.SHOW_ADD_PRESENTER_OVERLAY:

            return Object.assign({}, state, {
                isAddOverlayOpen: true,
                formMode: 'add'
            });

        case presenterList.HIDE_ADD_PRESENTER_OVERLAY:

            return Object.assign({}, state, {
                isAddOverlayOpen: false
            });

        case presenterList.SHOW_DELETE_PRESENTER_OVERLAY:

            return Object.assign({}, state, {
                isDeleteOverlayOpen: true,
                presenterToDelete: action.presenter
            });

        case presenterList.HIDE_DELETE_PRESENTER_OVERLAY:

            return Object.assign({}, state, {
                isDeleteOverlayOpen: false,
                presenterToDelete: null
            });

        case presenterList.PRESENTERS_REFRESHED:

            return Object.assign({}, state, {
                presenters: action.presenters
            });

        case presenterList.UPDATE_PRESENTER_SEARCH_RESULTS:

            return {
                ...state,
                searchResults: action.searchResults
            }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/presenterList.js